import React, { useState } from 'react';
import { QuirkVirtualList } from './QuirkVirtualList.js';
import { QuirkLoader } from './QuirkLoader.js';
import { NoResults } from './NoResults.js';
import styles from './SelectCommunity.module.css';
import { SearchBar } from './Forms/SearchBar.js';
import { CommunityItem } from './CommunityItem.js';
import { searchCommunities } from '../util/community.js';
import { IconGlobe } from './QuirkIcons/index.js';
import { QuirkCommunity } from 'model';

export interface SelectInstanceProps {
	domain?: string | null;
	onChange?: (community: QuirkCommunity) => void | Promise<void>;
	communities: QuirkCommunity[] | null;
}

export function SelectCommunity({ domain, onChange, communities }: SelectInstanceProps) {
	const [search, setSearch] = useState('');
	const onSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setSearch(e.target.value);
	};

	const results = searchCommunities(search, communities ?? []).sort(({ hostname: a }, { hostname: b }) =>
		a === domain ? -1 : b === domain ? 1 : 0
	);

	const onSelect = (community: QuirkCommunity) => {
		onChange?.(community);
	};

	return (
		<div className={styles.SelectCommunity}>
			<div>
				<SearchBar value={search} onChangeAction={onSearchChange} debounce={300} placeholder="search" />
			</div>
			<div className={styles.communitiesContainer}>
				<QuirkLoader
					isLoading={!communities}
					data={results}
					noResults={
						<NoResults
							heading="No communities found."
							subheading={search !== '' ? 'Try a different search' : ''}
							icon={<IconGlobe />}
						/>
					}
				>
					<QuirkVirtualList
						ItemComponent={({ item }, i) => (
							<CommunityItem
								item={item}
								current={domain === item.hostname}
								onSelect={onSelect}
								key={item.hostname + `-${i}`}
							/>
						)}
						items={results}
					/>
				</QuirkLoader>
			</div>
		</div>
	);
}
